import React, { ElementType } from "react";
import Tab, { TabProps } from "@mui/material/Tab";

interface Props extends TabProps {
  label?: string
  to?: string
  component?: ElementType
  onClick?: (event: { preventDefault: () => void }) => void
}

export default function LinkTab(props: Props) {
  return <Tab {...props} />;
}
